import {createSelector} from '@ngrx/store';
import {AppState} from '../states/app.state';
import {BelegKettenKnotenDTO} from '../../openapi/fakturierung-openapi';


export class BelegKetteSelectors {

  private static slice = (state: AppState) => state.belegKette;

  private static byBelegId = createSelector(
    this.slice,
    slice => slice.byBelegId,
  );

  /**
   * Alle Knoten der Kette des Belegs in der Reihenfolge des Backends (Eltern vor Kindern,
   * Geschwister chronologisch). Leer, solange nichts geladen ist.
   */
  public static kette = (belegId: string) => createSelector(
    this.byBelegId,
    byBelegId => byBelegId[belegId]?.knoten ?? [],
  );

  /**
   * Vorgaenger des Belegs ueber `quellBelegId`, chronologisch vom Ursprung her.
   * Der Beleg selbst ist nicht enthalten; leer bei einer Wurzel oder solange nichts geladen ist.
   */
  public static pfadNachOben = (belegId: string) => createSelector(
    this.kette(belegId),
    knoten => {
      const knotenById = new Map(knoten.map(k => [k.belegId, k]));
      const pfad: BelegKettenKnotenDTO[] = [];
      const besucht = new Set<string>([belegId]);
      let quellBelegId = knotenById.get(belegId)?.quellBelegId;
      while (quellBelegId && !besucht.has(quellBelegId)) {
        const quelle = knotenById.get(quellBelegId);
        if (!quelle) break;
        besucht.add(quellBelegId);
        pfad.unshift(quelle);
        quellBelegId = quelle.quellBelegId;
      }
      return pfad;
    },
  );

  /**
   * IDs der Belege, deren bereits geladene Kette mindestens einen der Belege als Knoten enthaelt.
   * Dient der Invalidierung nach Konvertierung, Storno und Loeschen; nie geladene Ketten fehlen.
   */
  public static geladeneKettenMit = (belegIds: string[]) => createSelector(
    this.byBelegId,
    byBelegId => Object.entries(byBelegId)
      .filter(([, kette]) => kette.knoten.some(k => belegIds.includes(k.belegId)))
      .map(([belegId]) => belegId),
  );
}
